import { defineComponent as i, computed as n, useAttrs as m, createElementBlock as c, openBlock as a, mergeProps as u, unref as h } from "vue";
import { useIllustrationOptimizer as p } from "@ds/plugin";
import { omit as l } from "../../utils/omit.js";
const d = ["height", "media", "srcset", "width"], I = /* @__PURE__ */ i({
  name: "RevIllustrationSource",
  /**
   * Do not automatically inherit attributes so that we can intercept them
   * and extract what we do not want to apply (in our case `srcset`).
   */
  inheritAttrs: !1,
  __name: "IllustrationSource",
  props: {
    src: {},
    width: {},
    height: {},
    media: {}
  },
  setup(t) {
    const r = t, s = p(() => r.src), o = n(() => l(m(), ["srcset"]));
    return (e, f) => (a(), c("source", u(o.value, {
      height: e.height,
      media: e.media,
      srcset: h(s).srcset,
      width: e.width
    }), null, 16, d));
  }
});
export {
  I as default
};
